import axios from "axios"
import { modalController } from "@ionic/vue"
import myConfig from "./config"
import PageDialog from "../components/PageDialog.vue"
import ResetPassword from "@/views/login/ResetPassword.vue"
import mqttServer from "@/js/mqtt"
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { alertModal } from "@/main"

//****************************************************
axios.defaults.baseURL = myConfig.config.API_ADDRESS

//****************************************************
const userinfo = JSON.parse(localStorage.getItem("userinfo") as string) || {}

const instructData = {
  project: "lxll",
  page: "teachIndex",
  module: "App",
  type: userinfo.userType,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
  msg: "",
}

async function presentAlert(message: string, code: number) {
  // const alert = await alertController.create({
  //     header: '提示信息',
  //     message: message,
  //     buttons: ['确定'],
  //     backdropDismiss: false
  // });
  // return alert.present();
  if (userinfo.isAdmin) {
    // presentAlertSync(message, code)
    openMsgToast(message)
    return
  }
  mqttServer
    .pushMsg(instructData, {
      params: [message, code],
      fn: "presentAlertSync",
      msgType: "function",
    })
    .then(() => {
      presentAlertSync(message, code)
    })
}

async function presentAlertSync(message: string, code: number) {
  const http = true
  const modal = await modalController.create({
    component: PageDialog,
    id: "PageDialog",
    backdropDismiss: false,

    componentProps: { message, http, code },
    cssClass: "center_modal_controller_class3",
  })
  return modal.present()
}

let isModalShowing = false

axios.interceptors.response.use(
  async (success) => {
    if (success.config?.skipInterceptors) return

    if (success && success.data) {
      const msg = success.data.message
        ? success.data.message.replace("老师", "陪练").replace("课", "训练")
        : ""

      // 如果消息包含"指令"，使用openMsgToast提示
      if (msg && msg.includes("指令")) {
        openMsgToast(msg)
        return success
      }

      if (success.data.code === 500 || success.data.code === 430) {
        alertModal(msg)
        return success
      }

      if (
        (JSON.stringify(success.data.code).substring(0, 2) == "90" ||
          JSON.stringify(success.data.code).substring(0, 2) == "95") &&
        success.data.code != "9000"
      ) {
        openMsgToast(msg)
        return
      }

      if (success.data.code === 10001) {
        console.log("打开弹框")
        modalController.dismiss()
        const modal = await modalController.create({
          component: ResetPassword,
          componentProps: {
            phone: "",
            account: "",
          },
          backdropDismiss: false,
          showBackdrop: false,
          cssClass: "modal_controller_class",
        })
        await modal.present()
        // return;
      }
      if (success.data.success) {
        if (success.data.message) {
          await presentAlert(msg, success.data.code)
        }
      } else {
        const topModal = await modalController.getTop()
        if (topModal) {
          console.log("topModal", topModal, topModal.classList.contains("modal_controller_class"))
          // 获取模态窗口的宿主元素
          if (!topModal.classList.contains("modal_controller_class")) {
            await modalController.dismiss()
          }
        }
        if (success.data.message) {
          if (success.data.code !== 10001) {
            // 10001 首次登陆，需要修改密码
            if (success.data.code === 10002) {
              // 10002 会话超时
              if (!isModalShowing) {
                isModalShowing = true
                const modal = await modalController.create({
                  id: "PageDialog",
                  component: PageDialog,
                  componentProps: { message: msg },
                  backdropDismiss: false,
                  cssClass: "center_modal_controller_class3",
                })
                await modal.present()
                modal.onDidDismiss().then(() => {
                  isModalShowing = false
                  location.replace("/login")
                })
              }
            } else {
              if (!isModalShowing) {
                await presentAlert(msg, success.data.code)
                isModalShowing = false
              }
            }
            return Promise.reject(success) // 阻止继续处理这个响应
          }
        }
      }
    } else {
      const s = success ? (success + "").replace("老师", "陪练").replace("课", "训练") : ""
      alert(s)
    }

    return success
  },
  async (error) => {
    console.log(error)
    sessionStorage.setItem("status", "")

    // alert("系统检测到网络连接不畅，请切换更佳的网络，点击“OK”继续练习！");
    // await presentAlert("权限不足！");
    //location.replace("/login");
    return
  }
)

export default {
  baseUrl: axios.defaults.baseURL, //java地址
  printURL: myConfig.config.PRINT_ADDRESS + "/index", //打印地址
  baseWS: myConfig.config.WSS_ADDRESS,
  aiUrl: myConfig.config.AI_ADDRESS,
  post(
    url: string,
    data: any,
    authorization?: string,
    headers?: any,
    params?: any,
    timeout?: any,
    flag?: any
  ) {
    const teacherToken = localStorage.getItem("teacherToken")

    let token = localStorage.getItem("token")

    if (token == null) {
      token = ""
    }

    axios.defaults.headers.common["Authorization"] = authorization ? authorization : token
    console.log("flag1", flag)

    axios.defaults.headers.common["Domain"] = myConfig.config.hostname?.replaceAll(
      "'",
      ""
    ) as string
    if (flag) {
      console.log("flag1", flag)
      axios.defaults.headers.common["TeacherToken"] = ""
    } else {
      console.log("flag2", flag)
      teacherToken && (axios.defaults.headers.common["TeacherToken"] = teacherToken)
    }
    return axios({
      method: "post",
      timeout,
      url: url,
      data,
      params,
      headers: headers == "" ? axios.defaults.headers : headers,
    })
  },

  get(url: string, params?: object,authorization?:string) {
    const teacherToken = localStorage.getItem("teacherToken")

    let token = localStorage.getItem("token")
    if (token == null) {
      token = ""
    }

    axios.defaults.headers.common["Authorization"] = authorization?authorization:token
    axios.defaults.headers.common["Domain"] = myConfig.config.hostname?.replaceAll(
      "'",
      ""
    ) as string
    if (teacherToken) {
      axios.defaults.headers.common["TeacherToken"] = teacherToken
    }
    return axios.get(url, { params })
  },

  getAvMqtt(url: string, flag?: any) {
    console.log("ttttt", url)
    let token = localStorage.getItem("token")
    if (token == null) {
      token = ""
    }
    axios.defaults.headers.common["TeacherToken"] = ""
    axios.defaults.headers.common["Authorization"] = token
    axios.defaults.headers.common["Domain"] = myConfig.config.hostname?.replaceAll(
      "'",
      ""
    ) as string
    return axios.get(url)
  },
}
